import React, { useEffect, useState } from 'react';
import Odd from './Odd';
import { aggregateBetsForPlayer } from '../data/utils/aggregateBetsForPlayer';
import { useGetOffsetClass } from '../utils/useGetOffsetClass';
import CashoutLabel from './CashoutLabel';
import XRouterLink from './seo/xrouter/XRouterLink';
import { getEventUrl } from '../utils/getEventUrl';

function getFirstLine(bets) {
    let bet = bets[0];
    for (let i = 0; i < bets.length; i++) {
        if (bets[i]?.mainLine  && String(bets[i].mainLine) == String(bets[i].handicap)) {
            bet = bets[i];
            break;
        }
    }
    return bet;
}

function OddSelector(props) {
    const odds = props.odds;
    const [odd, setOdd] = useState(props.odds[0]);
    const [toggled, setToggled] = useState(false);

    function openDropdown() {
        if (odds.length === 1) {
            return;
        }

        setToggled(!toggled);
    }

    function changeOdd(odd) {
        setOdd(odd);
        setToggled(false);
    }

    const selected = odds.find(o => o.uniqueId === odd.uniqueId);

    return (
        <>
            <div className="relative flex flex-col">
                <div className="my-1 px-1 grid grid-cols-12 items-center justify-between border border-cs7 rounded-lg" onClick={openDropdown}>
                    <span className="col-start-1 col-end-12 font-medium text-xs truncate">{selected.descForBetsAggregate}</span>
                    {odds.length > 1 &&
                        <i className="col-start-12 col-end-13 justify-self-center xs-font-icon bi-chevron-expand" />
                    }
                </div>
                {toggled && 
                    <div className="max-h-[200px] overflow-y-auto mb-1 bg-cs1 border border-cs7 rounded-lg">
                        {odds.map(o => {
                            const classes = o.uniqueId === selected.uniqueId ? 'bg-cs4 text-cs1 first:rounded-t-md last:rounded-b-md' : 'text-cs6';
                            return (
                                <div key={o.uniqueId} className={`p-2 flex items-center justify-between font-medium text-xs ${classes}`} onClick={() => changeOdd(o)}>
                                    <span>{o.descForBetsAggregate}</span>
                                    <span>{o.value}</span>
                                </div>
                            );
                        })}
                    </div>
                }
                <Odd data={selected} />
            </div>
        </>
    );
}

export function ScorerOddsSelectorInner(props) {
    let bets = props.bets;
    bets = aggregateBetsForPlayer(bets, bets[0].tipoHandicap);

    const [handicap, setHandicap] = useState(getFirstLine(bets).handicap);
    const [toggled, setToggled] = useState(false);

    function changeHandicap(handicap) {
        setHandicap(handicap);
        setToggled(false);
    }

    const selected = bets.find(b => b.handicap === handicap);
    const odds = selected.odds.filter(o => o.value != null);

    return (
        <div className="p-2 pt-0">
            <div className="my-1 px-1 grid grid-cols-12 items-center justify-between border border-cs7 rounded-lg" onClick={() => setToggled(!toggled)}>
                <span className="col-start-1 col-end-12 font-medium text-xs truncate">{selected.desc}</span>
                <i className="col-start-12 col-end-13 justify-self-center xs-font-icon bi-chevron-expand" />
            </div>
            {toggled && 
                <div className="max-h-[200px] overflow-y-auto mb-1 bg-cs1 border border-cs7 rounded-lg">
                    {bets.map(b => {
                        const classes = b.handicap === selected.handicap ? 'bg-cs4 text-cs1 first:rounded-t-md last:rounded-b-md' : 'text-cs6';
                        return (
                            <div key={b.uniqueId} className={`p-2 flex items-center justify-between font-medium text-xs ${classes}`} onClick={() => changeHandicap(b.handicap)}>
                                <span>{b.desc}</span>
                            </div>
                        );
                    })}
                </div>
            }
            <OddSelector key={selected.uniqueId} odds={odds} />
        </div>
    );
}

export default function ScorerOddsSelector(props) {
    const [toggled, setToggled] = useState(props.toggled);
    useEffect(() => {
        if (props.toggle != null && props.toggle !== toggled) {
            setToggled(props.toggle);
        }
    }, [props.toggle]);

    const offsetClass = useGetOffsetClass();

    let bets = props.bets;
    const firstBet = bets[0];

    return (
        <>
            <div className="xs_scorerOddsSelector relative flex flex-col">
                {props.stickyDesc ?
                    <div className={`sticky ${offsetClass} p-2 h-full text-center font-medium text-xs uppercase`}>{firstBet.aggDesc}</div>
                    :
                    <div className="flex flex-col bg-cs7">
                        <div className="min-h-[40px] grid grid-cols-11 justify-items-center items-center border-b border-b-cs1" onClick={() => setToggled(!toggled)}>
                            <div className="w-full col-start-1 col-end-11 pl-2 flex shrink-0 items-center justify-between">
                                <span className="font-bold text-sm text-cs3 uppercase">{firstBet.aggDesc}</span>
                                <CashoutLabel bet={firstBet} />
                            </div>
                            <div className="w-full col-start-11 col-end-12 flex items-center justify-center font-medium text-md text-cs3">
                                {toggled ?
                                    <i className="bi-chevron-up"></i>
                                    :
                                    <i className="bi-chevron-down"></i>
                                }
                            </div>
                        </div>
                    </div>
                }
                {toggled &&
                    <ScorerOddsSelectorInner bets={bets} />
                }
            </div>
        </>
    );
}

export function ScorerOddsSelectorAlt(props) {
    const offsetClass = useGetOffsetClass();

    const e = props.event;
    let bets = props.bets;

    return (
        <div className="xs_scorerOddsSelector">
            <div className={`sticky ${offsetClass}`}>
                <div className="p-2 flex items-center justify-between bg-cs7 text-cs6">
                    <XRouterLink to={getEventUrl(e)} data={e} state={e} className="font-medium text-sm">{e.team1} v {e.team2}</XRouterLink>
                    <span className="text-sm">{e.date}</span>
                </div>
            </div>
            <ScorerOddsSelectorInner bets={bets} />
        </div>
    );
}
